module.exports = __webpack_public_path__ + "img/328.ef2518d9.png";